import { AnalyticTrackingBasePropertiesObj, TrackingGeneralProp } from './AnalyticTrackingBasePropertiesObj';
import { PageName, SubSection } from '@utils/pageConfig/Types';
import { doAmplitudeAnalyticsTracking } from '../PageAnalytics';

//Example of tracking for - Page Navigation
/**
 "analytics.track("Navigation Clicked", {
 "access"": "Retail Insights",
 "linkName": "Category Leaderboard",
 "navigationSource": "Jump Point"     //or "Graph", "Main Navigation"
 "pageName": "Retailer Overview",
 "section": "Retail Intelligence",
 "subsection": "Retailer Overview"
 })
 **/

export const PAGE_NAVIGATE_TRACKING_TITLE = 'Navigation Clicked';

export enum NavigateSourceType {
  JUMP_POINT = 'Jump Point',
  GRAPH = 'Graph',
}

//Extend base properties
export interface PageNavigateTracking extends AnalyticTrackingBasePropertiesObj {
  linkName: string;
  navigationSource: string;
}

export interface PageNavigateTrackingFunctionParam {
  eventTitle: string;
  track: (event: string, properties?: Object) => void;
  pageName: PageName;
  linkName: string;
  navigationSource: string;
  access: Object;
  subSection: SubSection;
}

export const pageNavigateTrackingFunction = (param: PageNavigateTrackingFunctionParam) => {
  const { pageName, linkName, navigationSource, track, eventTitle, access, subSection } = param;

  const pageNavigateProperties: PageNavigateTracking = {
    access: access,
    pageName: pageName,
    section: TrackingGeneralProp.SECTION_TRACKING_PROP,
    subsection: subSection ?? pageName,
    linkName: linkName,
    navigationSource: navigationSource,
  };

  doAmplitudeAnalyticsTracking(eventTitle, track, pageNavigateProperties);
};
